export const GET_COMPONENT = 'meganav/GET';
